import { createStyles } from '@material-ui/styles'
import { ThemeType } from 'theme'
import { DESKTOP, MOBILE, TABLET } from 'utils/styles'

export const MenuStyles = (theme: ThemeType) =>
  createStyles({
    'top-bar': {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      cursor: 'pointer',
      justifyContent: 'space-between',
      position: 'sticky',
      '-webkit-transform': 'translateZ(0)',
      '-webkit-backface-visibility': 'hidden',
      top: 0,
      backgroundImage: `linear-gradient(to bottom, ${theme.palette.black()}, ${theme.palette.black(
        0.7
      )})`,
      zIndex: 10,
      '& > *': {
        '-webkit-transform': 'translateZ(0)',
      },
      [`@media ${DESKTOP}`]: {
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        height: theme.constants.sizes.desktop.topBarHeight,
      },
      [`@media ${MOBILE}`]: {
        alignItems: 'center',
        height: theme.constants.sizes.phone.topBarHeight,
      },
    },
    'info-button': {
      margin: 0,
      backgroundColor: 'transparent',
      [`@media ${DESKTOP}`]: {
        width: theme.constants.sizes.desktop.topBarHeight,
        height: theme.constants.sizes.desktop.topBarHeight,
        borderLeft: `1px solid ${theme.palette.white(0.6)}`,
      },
      [`@media ${MOBILE}`]: {
        width: theme.constants.sizes.phone.topBarHeight,
        height: theme.constants.sizes.phone.topBarHeight,
        padding: 0,
      },
    },
    'close-icon': {
      [`@media ${MOBILE}`]: {
        width: '25%',
      },
    },
    'info-icon': {
      [`@media ${MOBILE}`]: {
        height: '30%',
      },
    },
    'button-placeholder': {
      width: 0,
    },
    icons: {
      display: 'flex',
      justifyContent: 'flex-end',
      position: 'relative',
    },
    'impressum-close-button': {
      position: 'absolute',
      right: 0,
      top: 0,
    },
    'mobile-icon': {},
    open: {
      '-webkit-backface-visibility': 'hidden',
      transform: 'translate(0, 0)',
      left: 0,
      opacity: 1,
      willChange: 'transform',
      transition: 'transform 0.5s, opacity 1s',
    },
    closed: {
      '-webkit-backface-visibility': 'hidden',
      transition: 'opacity 1s, transform 0.5s',
      transform: 'translate(-200vw, 0)',
      opacity: 0,
    },
    menu: {
      display: 'flex',
      width: '100%',
      boxSizing: 'border-box',
      paddingTop: theme.constants.sizes.desktop.topBarHeight,
      paddingBottom: theme.constants.sizes.desktop.bottomBarHeight,
      paddingLeft: theme.constants.sizes.desktop.sideBarWidth,
      [`@media ${DESKTOP}`]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        position: 'absolute',
        bottom: 0,
        left: 0,
      },
      [`@media only screen and (orientation: landscape) and ${TABLET}`]: {
        paddingBottom: theme.constants.sizes.tablet.bottomBarHeight,
      },
      [`@media ${MOBILE}`]: {
        flexDirection: 'column',
        padding: 0,
      },
    },
    'impressum-container': {
      top: theme.constants.sizes.desktop.topBarHeight,
      right: 0,
      padding: '5rem 10% 1rem 10%',
      background: theme.palette.white(),
      zIndex: 25,
      position: 'absolute',
      height: `calc(100% - ${theme.constants.sizes.desktop.topBarHeight}px)`,
      [`@media ${MOBILE}`]: {
        height: `calc(100% - ${theme.constants.sizes.phone.topBarHeight}px)`,
        padding: 0,
        top: theme.constants.sizes.phone.topBarHeight,
        background: theme.palette.black(),
      },
    },
    'menu-container': {
      width: '100%',
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      zIndex: 20,
      fontFamily: theme.fonts.primary.sansSerif,
      background: theme.palette.sideElements.desktop.background,
      [`@media ${DESKTOP}`]: {
        overflow: 'hidden',
      },
      [`@media ${MOBILE}`]: {
        overflow: 'auto',
        background: theme.palette.sideElements.phone.background,
      },
    },

    'chapter-section-wrapper': {
      display: 'flex',
      [`@media ${DESKTOP}`]: {
        paddingLeft: `${theme.constants.sizes.desktop.sideBarWidth}px`,
      },
    },
  })
